import { Component, effect, inject, untracked } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@bayclubs/horizon';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent {

    private readonly horizonAuth = inject(AuthService);
    private readonly router = inject(Router);

    constructor() {
        // MSAL can finish handling the redirect after this page is rendered,
        // so leave the login page as soon as the user becomes authenticated.
        effect(() => {
            if (this.horizonAuth.isAuthenticated()) {
                untracked(() => this.router.navigate(['/']));
            }
        });
    }

    public login(): void {
        this.horizonAuth.loginRedirect();
    }
}
